import { UserRole } from "../@types/userRole"

export const getUserRole = (userType: number): UserRole => {
  switch (userType) {
    case 1: return "Administrator";
    case 2: return "Analyst";
    case 3: return "Consumer";
    default: return "Consumer";
  }
}